module.exports = __webpack_public_path__ + "img/20170504.83e5ddd1.png";